import React from 'react'

export default function Step1RightContent () {
  return (
    <>
      <div className="title title--h4">AMU-kurser er for alle</div>
      <div className="wysiwyg">Arbejdsmarkedsuddannelser (AMU-kurser) er korte kurser målrettet ufaglærte og faglærte eller ledige. Alle kan tage på et AMU-kursus uanset uddannelsesbaggrund, men for faglærte/ufaglærte og ledige er der visse fordele.
      </div>
      <div className="title title--h6">Fordelene er mange</div>
      <div className="content-columns">
        <div className="content-columns__column">
          <div className="title title--h7">Faglært/ufaglært</div>
          <div className="wysiwyg wysiwyg--fs14">Er du ufaglært eller har du en erhvervsuddannelse som fx tømrer, frisør, salgsassistent eller indkøbs-assistent, så er du i AMU-mål-gruppen og har disse fordele:
            <ul>
              <li>Du deltager på kurset til AMU-pris</li>
              <li>Din virksomhed kan søge om VEU-godtgørelse</li>
            </ul>
          </div>
        </div>
        <span className="content-columns__separator"></span>
        <div className="content-columns__column">
          <div className="title title--h7">Ledig</div>
          <div className="wysiwyg wysiwyg--fs14">Som ledig har du mulighed for at dit jobcenter eller din a-kasse betaler dele af eller hele dit kursus. Tal med dit jobcenter og din a-kasse om dine muligheder inden du tilmelder dig.
          </div>
        </div>
      </div>
    </>
  )
}